import React from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { createChatSession } from '../../slices/LeoSlice';
import { AppDispatch, RootState } from '../../types';
import Button from '../Button';

interface SessionRetryProps {}

const SessionRetry: React.FC<SessionRetryProps> = () => {
  const dispatch = useDispatch<AppDispatch>();
  const {
    leo: { loading },
    auth: { authUserDetail },
  } = useSelector((state: RootState) => ({
    leo: state.leo,
    auth: state.auth,
  }));
  const id = authUserDetail?.id!;
  return (
    <div className='flex-grow flex flex-col pb-2 items-center justify-center h-full'>
      <p className='text-center text-white text-lg pb-6'>
        We&apos;re having trouble connecting to Leo. Please try again.
      </p>
      <Button
        onPress={() => {
          if (id) {
            dispatch(createChatSession(id!));
          }
        }}
        label='Try Again'
        isDisabled={loading}
        isSubmitting={loading}
      />
    </div>
  );
};

export default SessionRetry;
